import styled from 'styled-components'
import { theme } from '../../../style/theme'
import { colorTheme } from '../../../style/theme/colorTheme'

export const NotificationWrap = styled.div`
	display: grid;
	grid-template-columns: auto max-content;
	gap: 1.25em;
	justify-content: space-between;
	align-items: center;
	padding: 0.93em 0;
	border-bottom: 1px dashed ${colorTheme.restaurant.notificationsModal.border};
`
NotificationWrap.displayName = 'NotificationWrap'

export const NotificationContent = styled.div`
	display: flex;
	gap: 0.32em;

	.coins {
		width: 1.56em;
		height: 1.5em;
		flex-shrink: 0;
		fill: ${colorTheme.restaurant.notificationsModal.iconBlue};
	}

	.bell {
		width: 1.75em;
		height: 1.25em;
		flex-shrink: 0;
		fill: ${colorTheme.restaurant.notificationsModal.iconOrange};
	}

	.timer {
		width: 1.43em;
		height: 1.5em;
		flex-shrink: 0;
		fill: ${colorTheme.restaurant.notificationsModal.iconOrange};
	}
	.chef-hat {
		width: 1.56em;
		height: 1.3em;
		flex-shrink: 0;
		fill: ${colorTheme.restaurant.notificationsModal.iconWhite};
	}
	&.cancelled {
		.chef-hat {
			fill: ${colorTheme.restaurant.notificationsModal.iconOrange};
		}
		.bell {
			fill: ${colorTheme.restaurant.notificationsModal.iconMuted};
		}
	}
`
NotificationContent.displayName = 'NotificationContent'

export const NotificationCancelledLabel = styled.span`
	font-family: ${theme.fontRobotoMedium};
	font-weight: 700;
`
NotificationCancelledLabel.displayName = 'NotificationCancelledLabel'

export const NotificationText = styled.div`
	color: ${colorTheme.restaurant.notificationsModal.text};
	font-family: ${theme.fontRobotoMedium};
	font-size: 1em;
	font-weight: 500;

	> span:first-child {
		font-family: ${theme.fontRobotoMedium};
		color: ${colorTheme.restaurant.notificationsModal.dateText};
	}

	> span:not(:first-child) {
		font-family: ${theme.fontRobotoMedium};
		color: ${colorTheme.restaurant.notificationsModal.text};
	}
`
NotificationText.displayName = 'NotificationText'

export const NotificationButtonWrap = styled.div`
	display: flex;
	height: 2.5em;
	padding: 0.5em 0.63em;
	align-items: center;
	gap: 0.32em;
	border-radius: 0.75em;
	border: 1px solid ${colorTheme.restaurant.notificationsModal.button.border};
	cursor: pointer;

	.white-cross {
		width: 0.93em;
		height: 0.93em;
		fill: ${colorTheme.restaurant.notificationsModal.button.icon};
	}

	.tableWaiter {
		width: 1.37em;
		height: 0.93em;
		fill: ${colorTheme.restaurant.notificationsModal.button.icon};
	}
`
NotificationButtonWrap.displayName = 'NotificationButtonWrap'

export const NotificationButtonText = styled.div`
	color: ${colorTheme.restaurant.notificationsModal.button.text};
	font-family: ${theme.fontRobotoMedium};
	font-size: 0.87em;
`
NotificationButtonText.displayName = 'NotificationButtonText'

export const NotificationEmpty = styled.div`
	display: flex;
	padding: 0.93em 0;
	justify-content: center;
	align-items: center;
	gap: 1.25em;

	.bell {
		width: 2.18em;
		height: 1.56em;
		flex-shrink: 0;
		fill: ${colorTheme.restaurant.notificationsModal.empty.icon};
	}
`
NotificationEmpty.displayName = 'NotificationEmpty'

export const NotificationEmptyText = styled.div`
	color: ${colorTheme.restaurant.notificationsModal.empty.text};
	font-family: ${theme.fontRobotoMedium};
	font-size: 1.25em;
`
NotificationEmptyText.displayName = 'NotificationEmptyText'

export const CounterWrap = styled.div`
	font-size: 1rem;
	display: flex;
	width: 1.5em;
	height: 1.5em;
	justify-content: center;
	align-items: center;
	border-radius: 0.75em;
	background: ${colorTheme.restaurant.notificationsModal.counter.background};
	transform: translateY(-0.87em);
	position: relative;

	&.modal {
		transform: translateY(-0.32em);
	}

	&.active {
		background: ${colorTheme.restaurant.notificationsModal.counter.backgroundActive};
	}
`
CounterWrap.displayName = 'CounterWrap'

export const CounterText = styled.div`
	color: ${colorTheme.restaurant.notificationsModal.counter.text};
	font-size: 0.87em;
	transform: translate(-50%, -50%);
	top: 50%;
	left: 50%;
	position: absolute;
`
CounterText.displayName = 'CounterText'

export const NotificationTitleWrap = styled.div`
	display: flex;
	gap: 0.12em;

	> div:first-child {
		color: ${colorTheme.restaurant.notificationsModal.title};
		font-family: ${theme.fontRobotoMedium};
		font-size: 1.25em;
	}
`
NotificationTitleWrap.displayName = 'NotificationTitleWrap'
